import { render, staticRenderFns } from "./PlatformItemDescription.vue?vue&type=template&id=2748e4e2&"
import script from "./PlatformItemDescription.vue?vue&type=script&lang=js&"
export * from "./PlatformItemDescription.vue?vue&type=script&lang=js&"
import style0 from "./PlatformItemDescription.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2748e4e2')) {
      api.createRecord('2748e4e2', component.options)
    } else {
      api.reload('2748e4e2', component.options)
    }
    module.hot.accept("./PlatformItemDescription.vue?vue&type=template&id=2748e4e2&", function () {
      api.rerender('2748e4e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/parts/target/PlatformItemDescription.vue"
export default component.exports